import React from "react";
import type { Locale } from "@procore/core-react";
import { I18nProvider } from "@procore/core-react";
import { useMFETranslations } from "@procore/cdn-translations";
import en from "@/translations/en.json";
import { getTranslations } from "@/translations";

type EnvironmentI18nProps = {
   locale: string;
};

const EnvironmentI18n = ({ children, locale }: React.PropsWithChildren<EnvironmentI18nProps>) => {
   const cdn = useMFETranslations(
      {
         type: "file",
         locale,
         absolute_file_path(locale) {
            return `lc-web-app/src/client/translations/${locale}.json`;
         },
      },
      { en },
      {
         oldTranslations: getTranslations(locale),
         enableCDN: true,
      },
   );

   return (
      <I18nProvider locale={locale as Locale} translations={cdn.translations} enableCDN>
         {children}
      </I18nProvider>
   );
};

export default EnvironmentI18n;
